import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/motion";

export const Collaborators = () => (
  <section id="collaborators" className="shell py-14 sm:py-20" data-testid="collaborators-section" data-analytics-section="collaborators">
    <Reveal className="flex flex-col justify-between gap-6 border-y border-white/15 py-9 md:flex-row md:items-center">
      <div><h2 className="text-2xl font-[520] tracking-tight text-fg sm:text-3xl">Integrate the best. Invent the rest.</h2><p className="mt-3 text-base text-fg-2">If you already solve part of the problem, let’s build together.</p></div>
      <Link to="/partners" className="inline-flex min-h-11 shrink-0 items-center gap-2 text-sm text-signal">Partner with us <ArrowUpRight className="h-4 w-4" /></Link>
    </Reveal>
  </section>
);
